import React from "react";
import Loadable from "../../react-loadable";

const WeaMind = Loadable({
  loader: () => import("./Mind"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaMind;



// WEBPACK FOOTER //
// ./ecology9/wea-mind/index.js